import React from 'react';
import { Select } from 'v3/components';
import { fetchCostCenters } from 'utils/fetches'

function Filters({ filters, setFilters, setSelectCostCenter }) {

  const handleChange = (selectedOptions) => {
    setFilters(old => ({ ...old, costCenter: selectedOptions }));
    setSelectCostCenter({})
  }

  return (
    <Select.Async
      label="Nome"
      placeholder="Digite para pesquisar centro de custo"
      onSearch={search => fetchCostCenters(search, true, true)}
      value={filters.costCenter}
      onChange={value => {
        handleChange(value);
      }}
      getOptionLabel={option => option.name}
      getOptionValue={option => option.id}
      modalHeading="Selecione um Centro de Custo"
      modalBodyTitle="Centros de Custo:"
      multiple
      horizontal
    />
  );
}

export default Filters;
